<template>
  <div class="components-goregist" v-if="!login && language == 'Ch' && false">
    <div class="regist">
      <div class="inner">
        <div class="title">获取您的大势智慧账号</div>
        <div class="input">
          <el-input v-model="phone" placeholder="输入您的手机号" style="width: 216px; position: relative; top: 5px; border: 0px"></el-input>
          <router-link :to="'/regist?phone='+phone"><el-button type="primary" style="position: relative; top: 5px; font-size: 24px; padding: 7px 16px">立即获取 <i class="el-icon-right"></i></el-button></router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import userApi from '@/api/user'

  export default {
    name: 'components-goregist',
    data () {
      return {
        phone: "",
        login: global.apis.isLogin(),
        language: global.apis.getLanguage()
      }
    },
    watch: {
      // 监控路由变化
      "$route": function() {
        this.login = global.apis.isLogin()
        this.language = global.apis.getLanguage()
      }
    },
    created(){
      this.login = global.apis.isLogin()
      this.language = global.apis.getLanguage()
    },
    mounted () {
    },
    methods:{

    }
  }
</script>

<style>
  .components-goregist .el-input__inner{
    border: 0px;
    font-size: 24px;
  }
</style>
<style scoped>
  .components-goregist{
    height: 100%;
    width: 100%;
    color: rgba(33,33,33,1);
  }
  .regist{
    height: 350px;
    text-align: center;
    padding-top: 210px;
  }
  .regist .title{
    font-size:24px;

    font-weight:500;
  }
  .regist .input{
    width: 390px;
    height: 50px;
    background-color: white;
    box-shadow:0px 0px 7px 0px rgba(4,0,0,0.15);
    border-radius: 4px;
    margin: 40px auto 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/goregist.vue